import {
    Columns,
    Element,
    Image,
    RouterLink,
    Section,
} from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { IGroup, ITeam } from '@zmedia/bm-soccer-ui/interface';
import Empty from '@zmedia/bm-soccer-ui/modules/shared/components/Empty';
import styles from './style.module.scss';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';

export function TournamentTeams(props: any) {
    const teams: ITeam[] = props.teams || [];
    const groups: IGroup[] = props.groups || [];

    const renderTeam = (item: ITeam) => {
        return (
            <Columns.Column key={item.id}>
                <RouterLink
                    className={styles['tournament-team']}
                    to={`${URL_SOCCER_PAGE.SUBPATH}${item.path}`}
                    title={item.name}
                >
                    <Image src={item.logo} alt={'Đội bóng ' + item.name} />
                    <Element className={styles['text']}>{item.name}</Element>
                </RouterLink>
            </Columns.Column>
        );
    };

    const renderTeams = (teams: ITeam[]) => {
        return teams.map((team) => {
            return renderTeam(team);
        });
    };

    if (ArrayUtils.isEmpty(teams) && ArrayUtils.isEmpty(groups)) {
        return (
            <Section>
                <Empty content="Chưa có đội bóng tham gia"></Empty>
            </Section>
        );
    }

    if (!ArrayUtils.isEmpty(groups)) {
        let _items: ITeam[] = [];
        groups.forEach((group: IGroup) => {
            _items = [..._items, ...(group.teams || [])];
        });

        _items.sort((a: ITeam, b: ITeam) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
        return (
            <Section>
                <Columns className={styles['column-teams']}>
                    {renderTeams(_items)}
                </Columns>
            </Section>
        );
    }

    return (
        <Section>
            <Columns className={styles['column-teams']}>
                {renderTeams(teams)}
            </Columns>
        </Section>
    );
}

export default memo(TournamentTeams);
